// Generated by ReScript, PLEASE EDIT WITH CARE


function attr(element, name) {
  var value = element.getAttribute(name);
  if (value == null) {
    return "";
  } else {
    return value;
  }
}

function data(element, name) {
  return attr(element, "data-" + name);
}

function text(element) {
  var value = element.textContent;
  if (value == null) {
    return "";
  } else {
    return value;
  }
}

function addClass(element, name) {
  element.classList.add(name);
}

function removeClass(element, name) {
  element.classList.remove(name);
}

function toggleClass(element, name) {
  return element.classList.toggle(name);
}

function toggleClassForce(element, name, force) {
  return element.classList.toggle(name, force);
}

function hasClass(element, name) {
  return element.classList.contains(name);
}

function on(element, type_, handler) {
  element.addEventListener(type_, handler);
  return function () {
    element.removeEventListener(type_, handler);
  };
}

function onWithOptions(element, type_, handler, options) {
  element.addEventListener(type_, handler, options);
  return function () {
    element.removeEventListener(type_, handler);
  };
}

function isHtmlElement(element) {
  return element.nodeType === 1;
}

function isNode(element) {
  var kind = element.nodeType;
  if (kind === 1) {
    return true;
  } else {
    return kind === 3;
  }
}

function isHtmlInputElement(element) {
  if (element.nodeType === 1) {
    return element.tagName === "INPUT";
  } else {
    return false;
  }
}

export {
  attr ,
  data ,
  text ,
  addClass ,
  removeClass ,
  toggleClass ,
  toggleClassForce ,
  hasClass ,
  on ,
  onWithOptions ,
  isHtmlElement ,
  isNode ,
  isHtmlInputElement ,
}
/* No side effect */
